import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { cotizacion,reinicio } from './reducers/todo-reducer';
import ModalComponent from './ModalCmpt';
import Cotizacion from './Cotizacion';
import InputRange from 'react-input-range';

const userData = ['nombre', 'apellidos', 'correo','telefono','ingreso','edad_actual','edadretiro','porSueldo','anios_pension'];
const initialState = {
    tTelefono:"celular",
    mensaje:{},
    edad_actual:"30",
    edadretiro:"65",
    fuma:"N",
    genero:"H",
    porSueldo:75,
    contacto:false,
    value4: {
        min: 30,
        max: 65,
    },
    loading: false
}


class App extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
       
    }

    componentWillReceiveProps(nextProps){

    
        if(nextProps.successCotiza){
            if(nextProps.successCotiza.exito){
                this.setState({successCotiza:nextProps.successCotiza});
            }else{
                this.setState({
                    propsModal:{exito:false,texto:nextProps.successCotiza.texto},
                    mostrar:true
                });
            }

            this.props.actions.reinicio();
        }

        if(nextProps.successRegresar){
            this.setState({successCotiza:null,state:nextProps.successRegresar.values});
        }
    }
    

    render() {

        if(this.state.successCotiza){
            console.log("succesCotiza ");
             console.log(this.state.successCotiza);
            return <Cotizacion cotizacion={this.state.successCotiza}/>
        }


        return (
            <div className="formulario-cotiza"  style={{maxWidth:"805px"}}>
                <div className="contenidoFormularioDesktop hidden-xs">
                    <div className=" col-md-12 col-sm-12 col-xs-12 contenidoDesktop">
                       <br/>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-6 col-sm-6 col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="nombre">Nombre <span className="requiredIn">*</span></label>
                                    <input type="text" maxLength="40" className="form-control" id="nombre" name="nombre"
                                    value={this.state.nombre ? this.state.nombre : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.nombre)
                                        :null
                                    }
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="apellidos">Apellidos <span className="requiredIn">*</span></label>
                                    <input type="text" maxLength="40" className="form-control" id="apellidos" name="apellidos"
                                    value={this.state.apellidos ? this.state.apellidos : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.apellidos)
                                        :null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8 col-sm-8 col-xs-8">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <label htmlFor="correo">Correo Electrónico <span className="requiredIn">*</span></label>
                                    <input type="text" maxLength="40" className="form-control" id="correo" name="correo"
                                    value={this.state.correo ? this.state.correo : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.correo)
                                        :null
                                    }
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-12 col-sm-12 col-xs-12">
                                    
                            <div className="col-md-6 col-sm-6 col-xs-6">
                                <div className="form-group">
                                <label htmlFor="tTelefono">Tipo de Teléfono <span className="requiredIn">*</span></label>
                                    <select  id="tTelefono" name="tTelefono" value={this.state.tTelefono ? this.state.tTelefono : ""}
                                    onChange={this.changeValues.bind(this)} className="form-control">
                                        <option value="celular">Celular</option>
                                        <option value="fijo">Fijo</option>
                                    </select>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.tTelefono)
                                        :null
                                    }
                                    
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-6">
                                <div className="form-group">
                                <label htmlFor="telefono">Teléfono (10 dígitos) <span className="requiredIn">*</span></label>
                                    <input type="text" maxLength="10" className="form-control" id="telefono" name="telefono"
                                    value={this.state.telefono ? this.state.telefono : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.telefono)
                                        :null
                                    }
                                    
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12">
                            
                            <div className="col-md-4 col-sm-4 col-xs-4">
                                
                                <label htmlFor="genero">Genero <span className="requiredIn">*</span></label>
                                <br/>
                                <div className="text-center">
                                    <label>Masculino <input type="radio" id="generoDesk" value="H" name="generoDesk" 
                                    checked={this.state.genero === 'H'} onChange={this.changeValues.bind(this)} /></label>
                                    &nbsp;
                                    <label>Femenino <input type="radio" id="generoDesk" value="M" name="generoDesk" 
                                    checked={this.state.genero === 'M'} onChange={this.changeValues.bind(this)} /></label>
                                </div>
                                
                            </div>

                            <div className="col-md-4 col-sm-4 col-xs-4">
                                
                                <label htmlFor="tTelefono">¿Fumas? <span className="requiredIn">*</span></label>
                                <br/>
                                <div className="text-center">
                                    <label>Si <input type="radio" id="fumaDesk" value="S" name="fumaDesk" 
                                    checked={this.state.fuma === 'S'} onChange={this.changeValues.bind(this)} /></label>
                                    &nbsp;
                                    <label>No <input type="radio" id="fumaDesk" value="N" name="fumaDesk" 
                                    checked={this.state.fuma === 'N'} onChange={this.changeValues.bind(this)} /></label>
                                </div>
                                
                            </div>

                            <div className="col-md-4 col-sm-4 col-xs-4">
                                <div className="form-group">
                                    <label htmlFor="ingreso">Ingreso Mensual <span className="requiredIn">*</span></label>
                                    <input type="text" maxLength="6" className="form-control" id="ingreso" name="ingreso"
                                    value={this.state.ingreso ? this.state.ingreso : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.ingreso)
                                        :null
                                    }
                                    
                                </div>
                            </div>
                        </div>


                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-6 col-sm-6 col-xs-6 text-left">
                                    <label>Edad Actual <span className="requiredIn">*</span></label><br/>
                                    <b style={{marginLeft:"20px",fontSize:"24px",color:"#002D74"}}>{this.state.edad_actual}</b>
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-6 text-right">
                                    <label>Edad a la que deseo retirarme <span className="requiredIn">*</span></label><br/>
                                    <b style={{marginRight:"77px",fontSize:"24px",color:"#002D74"}}>{this.state.edadretiro}</b>
                            </div>

                        </div>

                        

                        <div className="col-md-12 col-sm-12 col-xs-12  " style={{marginTop:"10px",marginBottom:"40px",paddingLeft:"33px"}}>
                            
                        <InputRange
                            maxValue={70}
                            minValue={18}
                            formatLabel={value => ` `}
                            value={this.state.value4}
                            onChange={(value) => {
                                if(value.min >= 18 && value.max <= 70) {
                                    var max = 0;
                                    var valor = {
                                        min : value.min
                                    };
                                    if (value.max < 55) {
                                        max = 55;
                                    } else {
                                        max = value.max; 
                                    }
                                    valor.max = max;
                                    this.setState({ value4: valor,edad_actual:value.min,edadretiro:max,mostrar:false });
                                }
                            }
                            
                            }
                            onChangeComplete={value => console.log(value)} />
                            <div className="reglaEdades">

                            </div>
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12" >
                            <div className="col-md-12 col-sm-12 col-xs-12" >
                                <label>% de mi sueldo que deseo recibir durante mi retiro <span className="requiredIn">*</span></label>
                            </div>
                        </div>

                        <div className="col-md-9 col-sm-9 col-xs-9  " style={{marginTop:"10px",marginBottom:"40px",paddingLeft:"33px"}}>
                        <div style={{marginLeft:"16px"}} id="rangoPorcentaje">
                        <InputRange 
                            maxValue={100}
                            minValue={50}
                            formatLabel={value => ` `}
                            value={this.state.porSueldo}
                            onChange={porSueldo => this.setState({ porSueldo,mostrar:false })}
                            onChangeComplete={porSueldo => console.log(porSueldo)} />
                            </div>
                            
                            <div className="reglaPorcentaje">

                            </div>
                           
                        </div>
                        <div className="col-md-2 col-sm-2 col-xs-2">
                            <label className="labelPorSeldo" style={{fontSize:"24px",paddingLeft:"40px"}}> {this.state.porSueldo}% </label>
                        
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-5 col-sm-5 col-xs-5">
                                <label htmlFor="anios_pension">Número de años que deseo recibir mi pensión <span className="requiredIn">*</span></label>
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-4">
                                <div className="form-group">
                                    <input type="text" maxLength="2" className="form-control" id="anios_pension" name="anios_pension"
                                    value={this.state.anios_pension ? this.state.anios_pension : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.anios_pension)
                                        :null
                                    }
                                    
                                </div>
                        </div>
                        
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-5 col-sm-5 col-xs-5">
                                <label htmlFor="anios_pension">¿Cuánto puedo ahorrar mensualmente para mi Retiro?</label>
                            </div>
                            <div className="col-md-5 col-sm-5 col-xs-5">
                                <div className="form-group">
                                    <input type="text" maxLength="6" className="form-control" id="ahorro_mensual" name="ahorro_mensual"
                                    value={this.state.ahorro_mensual ? this.state.ahorro_mensual : ""}
                                    onChange={this.changeValues.bind(this)}/>
                                    {
                                        this.state.mensaje ? 
                                            this.validationMsj(this.state.mensaje.ahorro_mensual)
                                        :null
                                    }
                                    
                                </div>
                            </div>
                        </div>
                        


                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop:"10px"}}>
                 
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label>
                                <input type="checkbox" name="contacto" className="classCheck"
                                    checked={this.state.contacto} onChange={this.changeValues.bind(this)}
                                /> Deseo ser contactado para seguimiento a mi cotización. Conozco y entiendo que mis datos serán tratados conforme al Aviso de Privacidad de GNP.
                            </label>
                        </div>
               
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12" id="divBtnCotizar">
                        <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                        <label>Los datos marcados con <span className="requiredIn">*</span> son obligatorios.</label>
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                            <button className="btn btn-gnp" onClick={this.enviar.bind(this)}>Cotizar</button>
                        </div>
                    </div>

                    
                    
                    
                </div>

                <div className="contenidoFormulario hidden-md hidden-sm hidden-lg">

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="nombre">Nombre <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="40" className="form-control" id="nombre" name="nombre"
                                value={this.state.nombre ? this.state.nombre : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.nombre)
                                    :null
                                }
                                
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="apellidos">Apellidos <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="40" className="form-control" id="apellidos" name="apellidos"
                                value={this.state.apellidos ? this.state.apellidos : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.apellidos)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="correo">Correo Electrónico <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="40" className="form-control" id="correo" name="correo"
                                value={this.state.correo ? this.state.correo : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.correo)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group formTipoTelefono">
                                <label htmlFor="tTelefono">Tipo de Teléfono <span className="requiredIn">*</span></label>
                            
                                <select  id="tTelefono" name="tTelefono" value={this.state.tTelefono ? this.state.tTelefono : ""}
                                onChange={this.changeValues.bind(this)} className="form-control">
                                    <option value="celular">Celular</option>
						            <option value="fijo">Fijo</option>
                                </select>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.tTelefono)
                                    :null
                                }
                                
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="telefono">Teléfono (10 dígitos) <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="40" className="form-control" id="telefono" name="telefono"
                                value={this.state.telefono ? this.state.telefono : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.telefono)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            
                            <label htmlFor="genero">Genero <span className="requiredIn">*</span></label>
                            <br/>
                            <div className="text-center">
                                <label>Masculino <input type="radio" id="genero" value="H" name="genero" 
                                checked={this.state.genero === 'H'} onChange={this.changeValues.bind(this)} /></label>
                                &nbsp;
                                <label>Femenino <input type="radio" id="genero" value="M" name="genero" 
                                checked={this.state.genero === 'M'} onChange={this.changeValues.bind(this)} /></label>
                            </div>
                            
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            
                            <label htmlFor="tTelefono">¿Fumas? <span className="requiredIn">*</span></label>
                            <br/>
                            <div className="text-center">
                                <label>Si <input type="radio" id="fuma" value="S" name="fuma" 
                                checked={this.state.fuma === 'S'} onChange={this.changeValues.bind(this)} /></label>
                                &nbsp;
                                <label>No <input type="radio" id="fuma" value="N" name="fuma" 
                                checked={this.state.fuma === 'N'} onChange={this.changeValues.bind(this)} /></label>
                            </div>
                            
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="ingreso">Ingreso Mensual <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="6" className="form-control" id="ingreso" name="ingreso"
                                value={this.state.ingreso ? this.state.ingreso : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.ingreso)
                                    :null
                                }
                                
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group formEdadActual">
                                <label htmlFor="edad_actual">Edad Actual <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="2" className="form-control" id="edad_actual" name="edad_actual"
                                value={this.state.edad_actual ? this.state.edad_actual : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.edad_actual)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group formEdadRetirarme">
                                <label htmlFor="edadretiro ">Edad a la que deseo retirarme <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="2" className="form-control" id="edadretiro" name="edadretiro"
                                value={this.state.edadretiro ? this.state.edadretiro : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.edadretiro)
                                    :null
                                }
                                
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group formPorcentaje">
                                <label htmlFor="porSueldo">% de mi sueldo que deseo recibir durante mi retiro <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="3" className="form-control" id="porSueldo" name="porSueldo"
                                value={this.state.porSueldo ? this.state.porSueldo : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.porSueldo)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group formPeriodo">
                                <label htmlFor="anios_pension">Número de años que deseo recibir mi pensión <span className="requiredIn">*</span></label>
                                <input type="text" maxLength="2" className="form-control" id="anios_pension" name="anios_pension"
                                value={this.state.anios_pension ? this.state.anios_pension : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.anios_pension)
                                    :null
                                }
                                
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="ahorro_mensual">¿Cuánto puedo ahorrar mensualmente para mi Retiro? </label>
                                <input type="text" maxLength="6" className="form-control" id="ahorro_mensual" name="ahorro_mensual"
                                value={this.state.ahorro_mensual ? this.state.ahorro_mensual : ""}
                                onChange={this.changeValues.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                        this.validationMsj(this.state.mensaje.ahorro_mensual)
                                    :null
                                }
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <label><input type="checkbox" name="contacto" className="classCheck"
                                checked={this.state.contacto} onChange={this.changeValues.bind(this)}/>
                                Deseo ser contactado para seguimiento a mi cotización. Conozco y entiendo que mis datos serán tratados conforme al Aviso de Privacidad de GNP.
                                </label>
                        </div>
                    </div>
                    

                    <div className="col-md-12 col-sm-12 col-xs-12" id="divBtnCotizar">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                        <label>Los datos marcados con <span className="requiredIn">*</span> son obligatorios.</label>
                        </div>

                        <div className="col-md-6 col-sm-6 col-xs-6 text-right">
                            <button className="btn btn-gnp" onClick={this.enviar.bind(this)}>Cotizar</button>
                        </div>
                    </div>

                </div>
                <ModalComponent propsModal={this.state.propsModal} mostrar={this.state.mostrar} />

                {
                    this.state.loading ? 
                    <div className="gnp-loading">
                        <div className="circle-orange"></div>
                        <div className="circle-blue"></div>
                        <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" 
                        className="fr-fic fr-dib" /></div>
                    </div>
                    : null
                }

            </div>
        );
    }

    cancelar(event) {

       

        this.setState({mostrar:false});
        this.setState(initialState);
    }
    parseInte(val){
        return parseInt(val);
    }
    validationMsj(msj){
        if(msj){
          return <p className="errorMsj">{msj}</p>;  
        }
        return null;
    }
    changeValues(event) {
        this.props.actions.reinicio();
        var name = event.target.name;
        var value = event.target.value;
        var mensaje = this.state.mensaje;
        var target = event.target;
        
        if(target.type === "checkbox"){
            value = target.checked;
        }

        if(name === "fumaDesk"){
            name = "fuma";
        }

        if(name==="generoDesk"){
            name="genero";
        }
        this.setState({mostrar:false});
		mensaje[name] = null;
        this.setState({ [name]: value, mensaje, mostrar: false });
      
    }


    enviar(event){
        this.setState({mostrar:false});
        var mensaje = this.state.mensaje;
        var valido = true;
      
        for(var i=0; i < userData.length; i++){
            var re;
            var plural=false;
            var msjToShow = null;
            if(!this.state[userData[i]]){
                mensaje[userData[i]] = "Campo requerido.";
                valido=false;
            }else if(this.state[userData[i]].toString().trim()===""){
                mensaje[userData[i]] = "Campo requerido.";
                valido=false;
            }else{
                switch (userData[i]) {
                    case 'correo':
                      re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      msjToShow = "un correo válido."
                      break;
                    case 'telefono':
                       re = /^\d{10}$/;
                       msjToShow="un teléfono válido.";
                      break;
                    case 'apellidos':
                      re = /^[a-z\u00E0-\u00FC ]+$/i;
                      msjToShow="apellidos válidos.";
                      break;
                    case 'nombre':
                      re = /^[a-z\u00E0-\u00FC ]+$/i;
                      msjToShow="un nombre válido.";
                      break;
                    case 'ingreso':
                      re = /^\d{1,6}$/;
                      msjToShow="un ingreso válido."; //cambiar
                        break;
                    case 'edad_actual':
                        re = /^\d{2}$/;
                        msjToShow="una edad válida.";
                          break;
                    case 'edadretiro':
                          re = /^\d{2}$/;
                          msjToShow="una edad válida.";
                            break;
                    case 'porSueldo':
                        re = /^\d{2,3}$/;
                        msjToShow="un porcentaje válido.";
                        break;
                    case 'anios_pension':
                        re = /^\d{1,6}$/;
                        msjToShow="un valor entre 5 y 25 años."; //cambiar
                          break;
                    default:
                      console.log(userData[i])
                  }
    
                if(re){
                  if(!re.test(this.state[userData[i]]) ){
                    if (plural) {
                      mensaje[userData[i]] = "Capture " + msjToShow + " válidos.";
                    } else {
                        mensaje[userData[i]]  = "Capture " + (msjToShow ? msjToShow : userData[i]) ;
                    }
                    valido=false;
                  }
                }
            }
        }

        //validaciones individuales

        if(this.state.ingreso){
            if(this.parseInte(this.state.ingreso) < 1000){
                mensaje.ingreso = 'El ingreso mensual mínimo es de $1,000 pesos.'
                valido=false;
            }
        }

        if(this.state.anios_pension){
            if(this.parseInte(this.state.anios_pension) < 5){
                mensaje.anios_pension = 'Años mínimos de pensión es de 5 años.';
                valido=false;
            }else if(this.parseInte(this.state.anios_pension) > 25){
                mensaje.anios_pension = 'Años máximos de pensión son 25 años.'
                valido=false;
            }
        }

        if(this.state.edad_actual){
            if(this.parseInte(this.state.edad_actual) < 18){
                mensaje.edad_actual = 'Edad mínima 18 años.'
                valido=false;
            }else if(this.parseInte(this.state.edad_actual) > this.parseInte(this.state.edadretiro)-1 && this.state.edadretiro.trim() !== ""){
                mensaje.edad_actual="Edad máxima "+ (this.parseInte(this.state.edadretiro)-1 )+" años."
                valido=false;
			}
        }


        if (this.parseInte(this.state.edad_actual) <= 55){
            var textoModal = false;
		    if (this.parseInte(this.state.edadretiro) >= 55 && this.parseInte(this.state.edadretiro) <= 59
                    && !(this.parseInte(this.state.edad_actual) >= 18 && this.parseInte(this.state.edad_actual) <= 45)
                ){
                textoModal = "Favor de seleccionar una edad de retiro superior.";
                valido=false;
			}
			else if (this.parseInte(this.state.edadretiro) >= 60 && this.parseInte(this.state.edadretiro) <= 64
                     && !(this.parseInte(this.state.edad_actual) >= 18 && this.parseInte(this.state.edad_actual) <= 50)
                    ){
                textoModal = "Favor de seleccionar una edad de retiro superior.";
                valido=false;
			}
			else if(this.parseInte(this.state.edadretiro) >= 65 && this.parseInte(this.state.edadretiro) <= 70
                        && !(this.parseInte(this.state.edad_actual) >= 18 && this.parseInte(this.state.edad_actual) <= 55)
                    ){
               console.log("deberia de entrar aqui");
                textoModal = "Favor de seleccionar una edad de retiro superior.";
                valido=false;

            }

            if(textoModal){
                this.setState({
                    propsModal:{exito:false,texto:textoModal},
                    mostrar:true
                });
            }
        }
        
        if(this.parseInte(this.state.porSueldo) < 50){
            mensaje.porSueldo = "Porcentaje mínimo 50.";
            valido=false;
        }else if(this.state.porSueldo > 100){
            mensaje.porSueldo ="Porcentaje máximo 100.";
            valido=false;
        }

        if(this.state.ahorro_mensual){
            var regex = /^\d{2,6}$/;
            if(!regex.test(this.state.ahorro_mensual) ){
                mensaje.ahorro_mensual = "Capture un ahorro mensual válido."
                valido=false;
            }else if(this.parseInte(this.state.ahorro_mensual) < 1000 || this.parseInte(this.state.ahorro_mensual) > 150000){
                mensaje.ahorro_mensual = "El ahorro mensual mínimo es de $1,000 pesos y máximo de $150,000 pesos.";
                valido=false;
            }
        }

       this.setState({mensaje});
    
        if(valido){
            
            if(this.state.contacto===false){
                this.setState({
                    propsModal:{exito:false,texto:"Favor de seleccionar el check de consentimiento para contacto y aviso de privacidad."},
                    mostrar:true
                });
           }else{
            var values = this.state;
            delete values.loading;
            this.setState({loading:true});
            this.props.actions.cotizacion(values);
           }
        }
     }



}


const mapStateToProps = (state) => {
    return {
        successCotiza: state.todoReducer.get("successCotiza"),
        successRegresar : state.todoReducer.get("successRegresar")
    };
  }
  
  
  const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            cotizacion : cotizacion,
            reinicio: reinicio
       }, dispatch)
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(App);



// WEBPACK FOOTER //
// ./src/App.js